import type { ComponentProps } from 'react'
import { Switch as SwitchPrimitive } from '@base-ui/react/switch'

import { cn } from '@/lib/utils'

function Switch({
  className,
  ...props
}: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'focus-visible:ring-ring/40 data-checked:bg-primary data-unchecked:bg-input inline-flex h-4.5 w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-colors outline-none focus-visible:ring-2 data-disabled:cursor-not-allowed data-disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="bg-background data-checked:translate-x-3.5 data-unchecked:translate-x-0.5 pointer-events-none block size-3.5 rounded-full shadow-lg transition-transform"
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
